module.exports = __webpack_public_path__ + "img/selected0-min.6802a73a.png";